const Admin = () => {
    return (
        <div>
            <h1>Admin Page</h1>
            <p>Page is currently under construction.</p>
        </div>
    );
};

export default Admin;
